<template>
  <div>
    <!-- Botón para abrir el modal -->
    <!-- <a class="waves-effect waves-light btn" @click="openModal">Abrir Modal</a> -->

    <!-- Modal -->
    <div id="my-modal" class="modal">
      <div class="modal-content">
        <h4>Se detectaron los siguientes problemas para iniciar la búsqueda:</h4>
        <slot></slot>
        <p>Lamentamos los inconvenientes, implementamos estas medidas para asegurar el rendimiento de la plataforma. Para solicitar rangos más amplios favor de enviar un mensaje a ventas@fyf.mx</p>
      </div>
      <div class="modal-footer">
        <a class="modal-close waves-effect waves-green btn-flat">Cerrar</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openModal() {
      const elem = document.getElementById('my-modal');
      const instance = M.Modal.init(elem, {});
      instance.open();
    },
  },
};
</script>
